module.exports = __webpack_public_path__ + "static/procesDystrybucjaDesktop@x1-dfeb280808ee454723e4b8bb9ef1b3a3.png";